import { render, staticRenderFns } from "./ChooseHome.vue?vue&type=template&id=0b772eea&scoped=true"
import script from "./ChooseHome.vue?vue&type=script&lang=js"
export * from "./ChooseHome.vue?vue&type=script&lang=js"
import style0 from "./ChooseHome.vue?vue&type=style&index=0&id=0b772eea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b772eea",
  null
  
)

export default component.exports